module.exports = __webpack_public_path__ + "static/assets/3f4b0c31b7b15d65d7e8fd32489c07c7.png";